/**
 * Transaction CRUD API. W dev mode pisze tylko do Zustand store
 * (mocki w pamięci). W prod robi addDoc/updateDoc/deleteDoc do Firestore —
 * onSnapshot listener z dataSync zaktualizuje store.
 */
import { addDoc, collection, deleteDoc, doc, updateDoc, serverTimestamp, Timestamp } from 'firebase/firestore';
import { db, COLLECTIONS, IS_DEV_MODE } from '../../lib/firebase';
import { useTransactionsStore, type Transaction, type TxType } from './transactionsStore';
import { generateId } from '../../lib/utils';

export interface NewTransactionInput {
  familyId: string;
  userId: string;
  type: TxType;
  amount: number; // grosze
  walletId: string;
  toWalletId?: string;
  categoryId: string | null;
  note: string;
  date: Date;
  isRecurring?: boolean;
  isPaused?: boolean;
}

export async function createTransaction(input: NewTransactionInput): Promise<void> {
  if (IS_DEV_MODE) {
    const tx: Transaction = {
      id: generateId('tx'),
      familyId: input.familyId,
      userId: input.userId,
      type: input.type,
      amount: input.amount,
      walletId: input.walletId,
      toWalletId: input.toWalletId,
      categoryId: input.categoryId,
      note: input.note,
      date: input.date,
      isRecurring: input.isRecurring ?? false,
      syncStatus: 'synced',
    };
    useTransactionsStore.getState().addTransaction(tx);
    return;
  }
  await addDoc(collection(db, COLLECTIONS.transactions), {
    familyId: input.familyId,
    userId: input.userId,
    type: input.type,
    amount: input.amount,
    walletId: input.walletId,
    toWalletId: input.toWalletId ?? null,
    categoryId: input.categoryId,
    note: input.note,
    date: Timestamp.fromDate(input.date),
    isRecurring: input.isRecurring ?? false,
    createdAt: serverTimestamp(),
  });
}

export async function updateTransactionRemote(
  id: string,
  patch: Partial<NewTransactionInput>,
): Promise<void> {
  if (IS_DEV_MODE) {
    const storePatch: Partial<Transaction> = { ...patch };
    useTransactionsStore.getState().updateTransaction(id, storePatch);
    return;
  }
  const data: Record<string, unknown> = { ...patch };
  if (patch.date) data.date = Timestamp.fromDate(patch.date);
  await updateDoc(doc(db, COLLECTIONS.transactions, id), data);
}

export async function deleteTransaction(id: string): Promise<void> {
  if (IS_DEV_MODE) {
    useTransactionsStore.getState().removeTransaction(id);
    return;
  }
  await deleteDoc(doc(db, COLLECTIONS.transactions, id));
}
